module.exports = __webpack_public_path__ + "img/coporativo-informe.83af4e30.png";